import {useInfiniteQuery} from 'react-query';
import {getRoom} from '../../../services/message';

const UseGetRoom = (id: string) => {
  const {
    data: messages,
    isLoading: isRoomLoading,
    refetch,
    fetchNextPage,
  } = useInfiniteQuery(
    ['getRoom', id],
    ({pageParam = 1, queryKey}) => getRoom(queryKey[1] as string, pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages[allPages.length - 1].next
          ? new URL(allPages[allPages.length - 1]?.next || '').searchParams.get(
              'page',
            )
          : undefined;
      },
    },
  );
  return {messages, isRoomLoading, refetch, fetchNextPage};
};

export default UseGetRoom;
